import { Component, OnInit, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { AlertDialogComponent } from 'src/app/shared/alert-dialog/alert-dialog.component';
import { TitleService } from 'src/app/shared/title.service';
import { Theme } from 'src/app/theme/theme';
import { UserInfo } from 'src/app/user-info';
import { BuyingPartsDialogComponent } from './buying-parts-dialog/buying-parts-dialog.component';
import { SelectAvatarService } from './select-avatar.service';

@Component({
  selector: 'app-select-avatar',
  templateUrl: './select-avatar.component.html',
  styleUrls: ['./select-avatar.component.scss'],
  providers: [SelectAvatarService],
  standalone: false
})
export class SelectAvatarComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private selectAvatarService = inject(SelectAvatarService);
  private titleService = inject(TitleService);
  private dialog = inject(MatDialog);

  private userInfo?: UserInfo;
  selectedSlotIndex = 0;

  constructor() {
    this.route.data.subscribe((data) => {
      this.userInfo = data['userInfo'];
    });
  }

  public get isLoading(): boolean {
    return this.selectAvatarService.isAvatarSubmitting;
  }

  get theme(): Theme {
    return this.userInfo.character.theme;
  }

  get isSubmitDisabled(): boolean {
    return this.selectAvatarService.isSubmitDisabled;
  }

  get missingRequiredSlotNames(): string[] {
    return this.selectAvatarService.missingRequiredSlots.map((slot) => slot.displayName);
  }

  ngOnInit() {
    this.titleService.setTitle('Update Avatar');
  }

  get slotLabels(): string[] {
    return this.selectAvatarService.avatarSlots.map((slot) => slot.displayName);
  }

  onClickSlotMenu(index: number) {
    this.selectedSlotIndex = index;
    this.selectAvatarService.selectSlot(this.selectAvatarService.avatarSlots[index].id);
  }

  onSubmit() {
    this.selectAvatarService.submitSelectAvatar();
  }

  get isBuyingParts(): boolean {
    return this.selectAvatarService.isBuyingParts;
  }

  get totalPrice(): number {
    return this.selectAvatarService.totalPrice;
  }

  onClickBuy() {
    this.dialog
      .open(BuyingPartsDialogComponent, {
        width: '420px',
        data: {
          theme: this.theme,
          parts: this.selectAvatarService.unownedSelectedParts
        }
      })
      .afterClosed()
      .subscribe((confirmed: boolean) => {
        if (confirmed) {
          this.buyParts();
        }
      });
  }

  private buyParts() {
    this.selectAvatarService.buyAvatarParts().subscribe({
      error: (err) => this.openErrorDialog(err?.error?.message)
    });
  }

  private openErrorDialog(error: string) {
    this.dialog.open(AlertDialogComponent, {
      width: '420px',
      data: {
        theme: this.theme,
        description: error
      }
    });
  }
}
